<template>
    <div class="ant" :style="color ? 'border: 1px solid orange;' : ''">
        <template v-if="rate_key == 1">
            <img src="/images/rates/ants/bad_full.svg" @click="select_ant('1')" />
            <v-progress-circular :rotate="90" :size="110" :width="8" :value="30" class="color-blue">
                {{ get_percent(rate, 'low') }}
            </v-progress-circular>
        </template>
        <template v-if="rate_key == 2">
            <img src="/images/rates/ants/good_full.svg" @click="select_ant('2')" />
            <v-progress-circular :rotate="90" :size="110" :width="8" :value="30" class="color-yellow">
                {{ get_percent(rate, 'middle') }}
            </v-progress-circular>
        </template>
        <template v-if="rate_key == 3">
            <img src="/images/rates/ants/cool_full.svg" @click="select_ant('3')" />
            <v-progress-circular :rotate="90" :size="110" :width="8" :value="30" class="color-green">
                {{ get_percent(rate, 'high') }}
            </v-progress-circular>
        </template>
    </div>
</template>

<script>
export default {
    name: 'PercentAnt',
    data: () => ({
        // пусть извне приходит
        ratew: 3,
        active: '',
    }),
    props: ['rate', 'rate_key', 'color'],
    components: {},
    computed: {},
    beforeMount() {},
    methods: {
        select_ant(value) {
            this.active = 'red'
            this.$emit('ant', value)
        },
        get_percent(rates, type) {
            if (rates) {
                let x = []
                switch (type) {
                    case 'low':
                        x = rates.filter((rate) => rate.rate == '1')
                        break
                    case 'middle':
                        x = rates.filter((rate) => rate.rate == '2')
                        break
                    case 'high':
                        x = rates.filter((rate) => rate.rate == '3')
                        break
                    default:
                        break
                }
                if (x.length == 0) return `0 %`
                switch (type) {
                    case 'low':
                        this.low = ((x.length / rates.length) * 100).toFixed()
                        break
                    case 'middle':
                        this.middle = ((x.length / rates.length) * 100).toFixed()
                        break
                    case 'high':
                        this.high = ((x.length / rates.length) * 100).toFixed()
                        break
                    default:
                        break
                }
                return ` ${((x.length / rates.length) * 100).toFixed()} %`
            }
        },
    },
}
</script>

<style scoped>
.ant {
    width: 296px;
    height: 190px;
    background: #ffffff;
    border-radius: 30px;
    display: flex;
    padding: 40px 35px;
    margin-bottom: 10px;
    justify-content: space-between;
}

.ant .color-blue {
    color: #4260a3 !important;
}

.ant .color-yellow {
    color: #faaf50 !important;
}

.ant .color-green {
    color: #65b337 !important;
}

.ant .color-blue .v-progress-circular__info,
.ant .color-yellow .v-progress-circular__info,
.ant .color-green .v-progress-circular__info {
    color: #1f0303;
    font-size: 28px;
}
</style>